module.exports = __webpack_public_path__ + "files/510477d9a858422f09bfd17afad6f619.png";